import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFileText, FiArrowRight, FiAlertCircle } from 'react-icons/fi';
import { getFormSettings } from '../services/supabaseClient';
import { FORMS } from '../config/forms';

const FormSelection = () => {
  const location = useLocation();
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [disabledMessage, setDisabledMessage] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      const { success, data, error: err } = await getFormSettings();
      if (success) {
        setSettings(data || {});
      } else {
        // Em caso de erro, não bloqueia a listagem (fallback: mostra todos)
        setError(err);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  // Exibir mensagem quando o usuário for redirecionado de um formulário desabilitado
  useEffect(() => {
    if (location.state?.formDisabled) {
      setDisabledMessage(location.state.formDisabled);
      // Limpa o state da história para não persistir ao recarregar
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const visibleForms = FORMS.filter((form) => settings[form.id] !== false);

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Formulários Disponíveis</h1>
        <p className="mt-2 text-gray-600">
          Selecione um dos formulários abaixo para iniciar o preenchimento dos dados para o Observatório Socioeconômico e Ambiental da RIDE-DF.
        </p>
      </div>

      {disabledMessage && (
        <div className="mb-6 flex items-start bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-md p-4">
          <FiAlertCircle className="mr-2 h-5 w-5 flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-medium">Formulário indisponível</p>
            <p className="text-sm mt-1">{disabledMessage}</p>
          </div>
        </div>
      )}

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-600"></div>
        </div>
      ) : visibleForms.length === 0 ? (
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <FiFileText className="mx-auto h-12 w-12 text-gray-300" />
          <p className="mt-4 text-gray-600">
            No momento não há formulários habilitados para preenchimento.
          </p>
          <p className="mt-1 text-sm text-gray-400">
            Entre em contato com o administrador do sistema.
          </p>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2">
          {visibleForms.map((form) => (
            <Link
              key={form.id}
              to={form.path}
              className={`block p-6 bg-white rounded-lg shadow-md transition-shadow duration-200 hover:shadow-lg`}
            >
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  {form.icon}
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="text-lg font-medium text-gray-900">{form.title}</h3>
                  <p className="mt-1 text-gray-600">{form.description}</p>
                  <div className="mt-4 flex items-center text-primary-600 font-medium">
                    <span>Acessar formulário</span>
                    <FiArrowRight className="ml-2 h-4 w-4" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {error && (
        <p className="mt-4 text-xs text-gray-400">
          Aviso: não foi possível verificar o estado dos formulários. Exibindo todos disponíveis no código.
        </p>
      )}
    </div>
  );
};

export default FormSelection;
